import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { NotepadPanel } from '../camera/NotepadPanel';
import { getAppraisal } from '../lib/appraisal';

export function Notepad() {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();
  const [jobName, setJobName] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!jobId) return;
    let cancelled = false;
    (async () => {
      try {
        const a = await getAppraisal(jobId);
        if (!cancelled) setJobName(a.policyholder_name ?? undefined);
      } catch {
        // non-fatal: panel still works without the job name
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [jobId]);

  if (!jobId) return <div className="p-4 text-sm text-red-600">Missing job ID.</div>;

  return (
    <div className="fixed inset-0 flex flex-col bg-white">
      <NotepadPanel
        jobId={jobId}
        jobName={jobName}
        onClose={() => navigate(`/job/${jobId}`)}
        footer={
          <button
            onClick={() => navigate(`/job/${jobId}/summary`)}
            className="w-full rounded-lg bg-eva-teal py-3 text-sm font-semibold text-white"
          >
            Generate summary →
          </button>
        }
      />
    </div>
  );
}
